import React from "react";
import PropTypes from "prop-types";
import CardActions from "@mui/material/CardActions";
import {Button} from "components/Shared";

const ActionButtons = ({buttonPropSets}) => {
  return (
    <CardActions
      sx={{
        "& > :not(:last-child)": {
          marginRight: 1,
        }
      }}
      disableSpacing
    >
      {buttonPropSets.map(({children, ...otherButtonProps}, index) =>
        <Button
          key={index}
          {...otherButtonProps}
        >
          {children}
        </Button>
      )}
    </CardActions>
  );
};

ActionButtons.propTypes = {
  //Array of sets of Buttons Props
  //Check out https://material-ui.com/api/button/ for more info on what these are
  buttonPropSets: PropTypes.array,
};

export default ActionButtons;